import dayjs from "dayjs";
import PropTypes from "prop-types";

import Presenter from "utils/PropTypesPresenter";

export default new Presenter(
  {
    name: PropTypes.string,
    slug: PropTypes.string,
    date: PropTypes.string,
    img: {
      alt: PropTypes.string,
      title: PropTypes.string,
      src: PropTypes.node,
    },
  },
  {
    date(h) {
      return dayjs(h.date);
    },
    title(h) {
      return h.img.title;
    },
    name(h) {
      return h.name;
    },
    alt(h) {
      return h.img.alt;
    },
    src(h) {
      return h.img.src;
    },
  },
);
